export function resolveEnvironmentApiUrl(hostname: string, fallback = '/api'): string {
  const apiDomain = 'api.programme-cee-actee.fr';

  if (hostname.includes('-pr') || hostname.includes('review')) {
    return `https://${hostname.replace('frontend', 'api')}`;
  }

  if (hostname === 'staging.app.programme-cee-actee.fr') {
    return `https://staging.${apiDomain}`;
  }

  if (hostname === 'preprod.app.programme-cee-actee.fr') {
    return `https://preprod.${apiDomain}`;
  }

  if (hostname === 'app.programme-cee-actee.fr') {
    return `https://${apiDomain}`;
  }

  if (hostname.includes('laureatv2-frontend-staging')) {
    return 'https://laureatv2-api-staging.osc-fr1.scalingo.io';
  }

  if (hostname.includes('laureatv2-frontend-preprod')) {
    return 'https://laureatv2-api-preprod.osc-fr1.scalingo.io';
  }

  if (hostname.includes('laureatv2-frontend-production')) {
    return 'https://laureatv2-api-production.osc-fr1.scalingo.io';
  }

  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return '/api';
  }

  return fallback;
}
